(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87405:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(88478);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ sendTokenToChromeExtension; }
/* harmony export */ });
const sendTokenToChromeExtension = (param)=>{
    let { extensionId , jwt  } = param;
    window.postMessage({
        from: "web",
        type: "auth",
        data: {
            jwt
        }
    }, "*");
//@ts-ignore
// browser.runtime.sendMessage("comkmphbheahfollkgkoofmaecmojpnj", { jwt }, (response) => {
//   console.log(response)
//   if (!response.success) {
//     console.log("error sending message", response);
//     return response;
//   }
//   console.log("Sucesss ::: ", response.message);
// });
};


/***/ }),

/***/ 88478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86539);
// import {
//   Link as ChakraLink,
//   Text,
//   Code,
//   List,
//   ListIcon,
//   ListItem,
// } from '@chakra-ui/react'
// import { CheckCircleIcon, LinkIcon } from '@chakra-ui/icons'
// import { Hero } from '../components/Hero'
// import { Container } from '../components/Container'
// import { Main } from '../components/Main'
// import { DarkModeSwitch } from '../components/DarkModeSwitch'
// import { CTA } from '../components/CTA'
// import { Footer } from '../components/Footer'
// const Index = () => (
//   <Container height="100vh">
//     <Hero />
//     <Main>
//       {/* <Text>
//         Example repository of <Code>Next.js</Code> + <Code>chakra-ui</Code> +{' '}
//         <Code>TypeScript</Code>.
//       </Text> */}
//       <List spacing={3} my={0}>
//         <ListItem>
//           <ListIcon as={CheckCircleIcon} color="green.500" />
//           <ChakraLink
//             href="/login"
//             flexGrow={1}
//             mr={2}
//           >
//             Login <LinkIcon />
//           </ChakraLink>
//         </ListItem>
//         {/* <ListItem>
//           <ListIcon as={CheckCircleIcon} color="green.500" />
//           <ChakraLink isExternal href="https://nextjs.org" flexGrow={1} mr={2}>
//             Next.js <LinkIcon />
//           </ChakraLink>
//         </ListItem> */}
//       </List>
//     </Main>
//     <DarkModeSwitch />
//     {/* <Footer>
//       <Text>Next ❤️ Chakra</Text>
//     </Footer>
//     <CTA /> */}
//   </Container>
// )
// export default Index

/* harmony default export */ __webpack_exports__["default"] = (_login__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ 86539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Auth": function() { return /* binding */ Auth; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+layout@2.1.9_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(21765);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+media-query@3.2.7_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(49985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+color-mode@2.1.9_react@18.2.0/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var color_mode_dist_index_esm = __webpack_require__(67373);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+image@2.0.11_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(51922);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+avatar@2.2.0_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/avatar/dist/index.esm.js
var avatar_dist_index_esm = __webpack_require__(38032);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.1_qtpcxnaaarbm4ws7ughq6oxfve/node_modules/next/router.js
var next_router = __webpack_require__(5516);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.1_qtpcxnaaarbm4ws7ughq6oxfve/node_modules/next/link.js
var next_link = __webpack_require__(59260);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+button@2.0.11_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(30212);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@chakra-ui+icon@3.0.11_5t7bkk6q574vskeot6qtu5gahi/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(90788);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-icons@4.6.0_react@18.2.0/node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(62709);
;// CONCATENATED MODULE: ./src/views/SignInForm.tsx





const SignInForm = (props)=>{
    const isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    const { discordUrl , ...htmlProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        spacing: "8",
        ...htmlProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                spacing: "6",
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                        src: "/NFTee_white_full.png",
                        width: 180,
                        margin: "0 auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                        spacing: {
                            base: "2",
                            md: "3"
                        },
                        textAlign: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                size: (0,dist_index_esm/* useBreakpointValue */.Sx)({
                                    base: "xs",
                                    md: "sm"
                                }),
                                children: "Log in to your account"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                                spacing: "1",
                                justify: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    color: "muted",
                                    children: "Don't have an account? Sign up"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                spacing: "6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
                    spacing: "4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: discordUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            variant: "primary",
                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                as: fa_index_esm/* FaDiscord */.j2d,
                                boxSize: "5"
                            }),
                            iconSpacing: "3",
                            children: "Sign in with Discord"
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/context/User.tsx
var User = __webpack_require__(86556);
// EXTERNAL MODULE: ./src/lib/extension.ts
var extension = __webpack_require__(57573);
;// CONCATENATED MODULE: ./src/pages/login.tsx
/*global chrome*/ 







const calbackUri = encodeURIComponent("https://nfteelabs.io/auth/discord");
const discordClientId = "956169956893007882";
const scope = "identify+guilds+email+applications.commands.permissions.update";
const discordUrl = "https://discord.com/api/oauth2/authorize?client_id=".concat(discordClientId, "&redirect_uri=").concat(calbackUri, "&response_type=code&scope=").concat(scope);
const Auth = ()=>{
    const { user , userLoaded  } = (0,react.useContext)(User/* UserContext */.S);
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        if (userLoaded && user) {
            const { jwt  } = user;
            (0,extension/* sendTokenToChromeExtension */.f)({
                extensionId: "gcbejbiapllmialiecbkfgiadgeblbdo",
                jwt
            });
            router.push("/app/settings");
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        minH: {
            base: "auto",
            md: "100vh"
        },
        bgGradient: (0,dist_index_esm/* useBreakpointValue */.Sx)({
            md: (0,color_mode_dist_index_esm/* useColorModeValue */.ff)("linear(to-r, blue.600 50%, white 50%)", "linear(to-r, blue.600 50%, gray.900 50%)")
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            maxW: "8xl",
            mx: "auto",
            width: "full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                    flex: "1",
                    display: {
                        base: "none",
                        md: "block"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(color_mode_dist_index_esm/* DarkMode */.t7, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            direction: "column",
                            px: {
                                base: "4",
                                md: "8"
                            },
                            height: "full",
                            color: "on-accent",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    align: "center",
                                    h: "32",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                                            src: "/NFTee_white_full.png",
                                            width: 180,
                                            marginTop: 24
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    flex: "1",
                                    align: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                        spacing: "8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Stack */.Kq, {
                                                spacing: "6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                                                        size: (0,dist_index_esm/* useBreakpointValue */.Sx)({
                                                            md: "lg",
                                                            xl: "lg"
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                                color: "blue.900",
                                                                fontSize: (0,dist_index_esm/* useBreakpointValue */.Sx)({
                                                                    md: "60px",
                                                                    xl: "80px"
                                                                }),
                                                                fontWeight: "bold",
                                                                children: "NFTee Labs"
                                                            }),
                                                            "Solana tools and services"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        fontSize: "lg",
                                                        maxW: "md",
                                                        fontWeight: "medium",
                                                        children: "Create an account and discover usefull tools for you and your community."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                                spacing: "4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(avatar_dist_index_esm/* AvatarGroup */.HE, {
                                                        size: "md",
                                                        max: (0,dist_index_esm/* useBreakpointValue */.Sx)({
                                                            base: 2,
                                                            lg: 5
                                                        }),
                                                        borderColor: "on-accent",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                name: "Le\xf3n / \uD83E\uDD81\uD83D\uDCBB.sol",
                                                                src: "https://pbs.twimg.com/profile_images/1516917421663264768/DYZfn57b_400x400.jpg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                name: "User 5",
                                                                src: "https://nqfyqo6ss4q2cekf3qfexsb3ysopqwa4krer26yy6hrlrwdgda.arweave.net/bAuIO9KXIaERRdwKS8g7xJz4_WBxUSR17GPHiuNhmGI"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                name: "User 4",
                                                                src: "https://reshcehldpz2fhq6w7vtf566lxubmfrmgvy4vpkwqgr46om2.arweave.net/iSRxEOsb86KeHr__frMvfeXegWFiw1ccq9VoGjzzmaM?ext=png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                name: "User 3",
                                                                src: "https://pbs.twimg.com/media/FN_Ic3eXwAQD-mC?format=png&name=small"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar_dist_index_esm/* Avatar */.qE, {
                                                                name: "User 2",
                                                                src: "https://pbs.twimg.com/media/FOK2zj0WYAURm2i?format=jpg&name=small"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                        fontWeight: "medium",
                                                        children: "Join 10.000+ users"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                    align: "center",
                                    h: "24",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        color: "on-accent-subtle",
                                        fontSize: "sm",
                                        children: "\xa9 2022 NFTee Labs. All rights reserved."
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                    flex: "1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignInForm, {
                        px: {
                            base: "4",
                            md: "8"
                        },
                        py: {
                            base: "12",
                            md: "48"
                        },
                        width: "full",
                        maxW: "md",
                        discordUrl: discordUrl
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var login = (Auth);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2848,1765,169,9774,2888,179], function() { return __webpack_exec__(87405); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);